import gql from "graphql-tag";

export const getOdeById = gql`
  query GetOdeById($id: ID!) {
    oDE(where: { id: $id }) {
      id
      name
      legalName
      odeID
      description
      hideDashboardAlert
      shortDescription
      technology
      commercialBussines
      sector
      socialComponent
      industry
      techBased
      social
      economicIndustry
      economicSector
      economicActivity
      streetAddress
      colonyAddress
      zipCode
      city
      address{
        country
        state
        city
        street
        neighborhood
      }
      country
      socialMedia
      businessModel
      product
      productStage
      salesStage
      annualSales
      market
      financingStage
      employeesAmount
      mainTechnology
      mainTechnologies
      patentStatus
      inventionType
      inventionRegister
      inventionRegisterDate
      createdAt
      presenceStates{
        id
        allCities
        cities
        value
        name
      }
      keywords
      logoUrl
      phone
      email
      trl
      technologyLevel
      socialFunction
      profitMotives
      businessName

      team{
        id
        fullName
        email
        phone
        systemRole
        profilePicUrl
      }
      files{
        id
        fileName
        url
        type
        uploadDate
      }
      pitch{
        id
        problem
        demoUrl
        market
        businessModel
        solution
      }
      fiscalAddress {
        id
        country
        state
        city
        street
        neighborhood
        zipCode
      }
      address {
        id
        country
        state
        city
        street
        neighborhood
        zipCode
      }
      reports{
        id
        startDate
        endDate
        companyStatus
        presales
        monthlySales
        productInDevelopment
        patentStatus
        productPhase
        trlLevels
        fundings
        contests
        hasEmployees
        currentEmployeesNumber
        terminatedEmployees
        hiredEmployees
        achievements
      }
      batches {
        id    
        name
        iname
        batchID
        startDate
        finishDate
        description
        program {
          id
          name
          type
        }
        odeStatusBatch(
          where: {
            ode: { id: $id }
          }
        ){
          id
          status
        }
      }
      startDate
      finishDate
      milestones(orderBy: createdAt_DESC){
        id
        milestoneType
        name
        description
        fundType
        source
        investor
        socialCompetence
        amount
        date
        place
        prize
        prizeDescription
        link
        currency
        createdAt
      }
      website
      facebook
      twitter
      instagram
      linkedin
      market
      mainTechnology
      socialComponent
      patentStatus
      tradeName
      product
      productStage
      salesStage
      fiscalState
      financingStage
      businessModel
      fiscalId
      fiscalRepresentative
      fiscalEntryDate
      rfc
      employeesAmount
      annualSales
      createdAt
    }
  }
`;

